// extracted by mini-css-extract-plugin
module.exports = {"modal":"AuthModal_modal__9fx0R","main":"AuthModal_main__aPPm7","changeTab":"AuthModal_changeTab__2efoL"};